<template>
  <div class="main-dashboard-panel program-details-page">
    <div class="panel-topnav container-fluid">
      <router-link :to="{ name: 'eventList' }" class="back-link pull-left">
        <i class="ion-ios-arrow-back text-yellow before"></i> All showrooms
      </router-link>
      <div class="clearfix"></div>
    </div>

    <router-view v-if="!noEvent" class="container-fluid pane" />
    <div v-if="noEvent" class="container-fluid pane">
      <p class="alert alert-warning">
        Event does not exist or you have no access to it.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getNewAppUrl } from '@/utils/urls'

export default {
  props: {
    eventId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
    }),
  },
  data() {
    return {
      noEvent: false,
    }
  },
  created() {
    window.location = getNewAppUrl(`/dashboard/showrooms/${eventId}`)
    this.fetch()
  },
  methods: {
    async fetch() {
      const detailsRequest = this.$store.dispatch('eventDetails/fetch', {
        eventId: this.eventId,
      })
      try {
        await detailsRequest
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.noEvent = true
        }
      }
    },
  },
}
</script>
